import { createContext } from 'react';

import { COUNTRIES, DEFAULT_COUNTRY_CODE } from '../constants/locations';
import {
  CookieConsentState,
  CountryCode,
  CurrencyCode,
  UnitsOfMeasure,
} from '../types/Locations';

export type UserPreferences = {
  currency: CurrencyCode;
  countryCode: CountryCode;
  unitOfMeasurement: UnitsOfMeasure;
  cookieConsent: CookieConsentState;
};

export type UserPreferencesContextType = {
  preferences: UserPreferences;
  setCountry(countryCode: CountryCode): void;
  setUnitOfMeasurement(unitOfMeasurement: UnitsOfMeasure): void;
  setCookieConsent(state: CookieConsentState): void;
};

export const defaultPreferences: UserPreferences = {
  cookieConsent: 'UNDECIDED',
  countryCode: DEFAULT_COUNTRY_CODE,
  currency: COUNTRIES[DEFAULT_COUNTRY_CODE].currency,
  unitOfMeasurement: COUNTRIES[DEFAULT_COUNTRY_CODE].unit,
};

export const UserPreferencesContext = createContext<UserPreferencesContextType>(
  {
    preferences: defaultPreferences,
    setCountry: () => {},
    setUnitOfMeasurement: () => {},
    setCookieConsent: () => {},
  },
);
